import React, { useState } from 'react';
import { useSearchParams, useNavigate, Link } from 'react-router-dom';
import api from '../utils/api';
import toast from 'react-hot-toast';

export default function ResetPasswordPage() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const navigate = useNavigate();

  if (!token) return (
    <div style={{ minHeight: '100vh', background: 'var(--navy)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: 'Inter, sans-serif' }}>
      <div style={{ textAlign: 'center' }}>
        <p style={{ color: 'var(--text-3)' }}>Invalid reset link.</p>
        <Link to="/forgot-password" style={{ color: 'var(--teal)' }}>Request a new one →</Link>
      </div>
    </div>
  );

  const submit = async (e) => {
    e.preventDefault();
    if (password !== confirm) return toast.error('Passwords do not match');
    if (password.length < 6) return toast.error('Password must be at least 6 characters');
    setLoading(true);
    try {
      await api.post('/auth/reset-password', { token, new_password: password });
      setDone(true);
      setTimeout(() => navigate('/login'), 2500);
    } catch (err) {
      toast.error(err.response?.data?.error || 'Invalid or expired link');
    } finally { setLoading(false); }
  };

  const inputStyle = { width: '100%', padding: '10px 12px', borderRadius: 8, background: 'var(--navy)', border: '1px solid var(--border-2)', color: 'var(--text-1)', fontSize: 14 };

  return (
    <div style={{ minHeight: '100vh', background: 'var(--navy)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '0 16px', fontFamily: 'Inter, sans-serif' }}>
      <div style={{ width: '100%', maxWidth: 380 }}>
        <div style={{ textAlign: 'center', marginBottom: 28 }}>
          <h1 style={{ fontSize: 20, fontWeight: 700, color: 'var(--text-1)' }}>New Password</h1>
        </div>
        <div style={{ background: 'var(--slate)', border: '1px solid var(--border)', borderRadius: 16, padding: '28px 24px' }}>
          {done ? (
            <div style={{ textAlign: 'center' }}>
              <div style={{ fontSize: 48, marginBottom: 12 }}>✅</div>
              <h3 style={{ fontSize: 16, fontWeight: 600, marginBottom: 8 }}>Password reset!</h3>
              <p style={{ fontSize: 13, color: 'var(--text-3)' }}>Redirecting you to login…</p>
            </div>
          ) : (
            <form onSubmit={submit} style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
              <div>
                <label style={{ fontSize: 12, color: 'var(--text-3)', display: 'block', marginBottom: 5 }}>New Password</label>
                <input type="password" required minLength={6} placeholder="Min. 6 characters" value={password} onChange={e => setPassword(e.target.value)} style={inputStyle} />
              </div>
              <div>
                <label style={{ fontSize: 12, color: 'var(--text-3)', display: 'block', marginBottom: 5 }}>Confirm Password</label>
                <input type="password" required placeholder="Repeat password" value={confirm} onChange={e => setConfirm(e.target.value)} style={inputStyle} />
              </div>
              <button type="submit" disabled={loading} style={{ padding: '12px 0', borderRadius: 10, border: 'none', background: 'var(--teal)', color: 'var(--navy)', fontWeight: 700, fontSize: 14, cursor: 'pointer', opacity: loading ? 0.7 : 1 }}>
                {loading ? 'Resetting…' : 'Reset Password'}
              </button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
